import { Component } from '@angular/core';
import { DataService } from '../../../../services/dashboard/data.service';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../services/auth/auth.service';
import { LogoutType } from '../../../../shared/enums/logoutType.enum';

@Component({
  selector: 'app-session-expired',
  imports: [CommonModule],
  templateUrl: './session-expired.component.html',
  styleUrl: './session-expired.component.css',
})
export class SessionExpiredComponent {
  isDialogVisible: boolean = false;

  constructor(
    private dataService: DataService,
    private authService: AuthService,
  ) {
    this.dataService.setTokenExpiredCallback(() => this.showDialog());
  }

  ngOnInit(): void {}

  showDialog(): void {
    this.isDialogVisible = true;
  }

  logout(): void {
    //this.authService.logout();
    this.authService.accessLogEnd(LogoutType.TOKEN_EXPIRED).subscribe({
      next: (res) => {
        // console.log('Log record successful');
        this.authService.logout();
      },
      error: (e) => {
        console.error('Log record failed');
        this.authService.logout();
      },
    });
    this.isDialogVisible = false; // Close the dialog
  }

  closeDialog(): void {
    this.isDialogVisible = false;
  }
}
